import { StyleSheet } from 'react-native';
export const styles = StyleSheet.create({
    error: {
        color: 'red',
    },
});
